import React from 'react'
import LevelOne from '../../maxillofacial/mobile/LevelOne';

const FracturePlatingSystem = () => {
	return (
		<LevelOne
			system={"fractureplatingSystem"}
		/>
	)
}

export default (FracturePlatingSystem)